<script setup>
import UseSvg from "common/vue/components/UseSvg.vue";
</script>

<template>
  <div class="preview-message">
    <UseSvg icon="warning" class="preview-message__icon" />

    <div class="preview-message__text">
      All custom design placements will be applied to the final product.
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/print-settings";

.preview-message {
  display: flex;
  gap: 9px;
  color: $text-black;
  padding: 6px;
  border-radius: 6px;
  background: linear-gradient(to right, #f8f3ff, #ebe5ff);

  &__icon {
    flex: none;
    width: 16px;
    height: 16px;
  }

  &__text {
    font-size: 11px;
    line-height: 16px;
  }
}
</style>
